<template>
  <span class="inline-flex items-center gap-1.5">
    Kontent
    <fixed-tooltip>
      <span
        class="inline-flex cursor-help"
        tabindex="0"
        aria-label="Informacja o śledzonym kontencie"
      >
        <icon name="question-mark" class="size-4 text-amber-500" />
      </span>
      <template #content>
        <p class="font-medium">
          Śledzone pola (pomarańczowa kropka):
        </p>
        <ul class="mt-1 list-disc pl-4">
          <li>Opis (PL, EN)</li>
          <li>Leczone choroby (PL, EN)</li>
          <li>Ważne informacje (PL, EN)</li>
        </ul>
        <p class="mt-2 font-medium">
          Nie śledzone:
        </p>
        <ul class="mt-1 list-disc pl-4">
          <li>Imię, nazwisko, tytuł, specjalizacje, opis zdalny, zdjęcie (Medfile)</li>
          <li>Języki, media, FAQ (opcjonalne)</li>
        </ul>
      </template>
    </fixed-tooltip>
  </span>
</template>

<script setup>
import FixedTooltip from '@/Shared/FixedTooltip.vue';
import Icon from '@/Shared/Icon.vue';
</script>
